/**
 * Datos ficticios de eventos para maquetación.
 * Reemplazar por API real cuando se implemente el módulo de eventos.
 */

export const eventosMock = [
  {
    id: "gala-anual-2026",
    nombre: "Gala Anual del Casino",
    fecha: "22 de febrero, 2026",
    hora: "20:30 h",
    lugar: "Salón Imperial",
    salon: "Salón Imperial",
    estado: "Venta disponible",
    precio: "$1,850 MXN",
    precioDesde: "$1,850 MXN",
    descripcion:
      "Una velada de gala que celebra la tradición del Casino Tampiqueño. Cena de tres tiempos, cóctel de bienvenida y orquesta en vivo en el histórico Salón Imperial.",
    codigoVestimenta: "Etiqueta rigurosa · Traje largo / Smoking",
    informacionAdicional:
      "Acceso permitido a socios y hasta dos acompañantes por membresía. Registro a partir de las 19:30 h. Estacionamiento con valet parking incluido.",
    imagen:
      "https://images.unsplash.com/photo-1777714294844-54a1416d70fa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBwcml2YXRlJTIwY2x1YiUyMGludGVyaW9yfGVufDB8fHx8MTc4MzYyNTkxMXww&ixlib=rb-4.1.0&q=85",
    mesas: [
      { numero: 1, capacidad: 10, disponibles: 8, x: 18, y: 24 },
      { numero: 2, capacidad: 10, disponibles: 3, x: 50, y: 22 },
      { numero: 3, capacidad: 10, disponibles: 0, x: 82, y: 26 },
      { numero: 4, capacidad: 10, disponibles: 2, x: 22, y: 58 },
      { numero: 5, capacidad: 10, disponibles: 6, x: 54, y: 60 },
      { numero: 6, capacidad: 8,  disponibles: 5, x: 84, y: 62 },
      { numero: 7, capacidad: 8,  disponibles: 0, x: 34, y: 86 },
      { numero: 8, capacidad: 8,  disponibles: 4, x: 68, y: 88 },
    ],
  },
  {
    id: "torneo-billar-primavera",
    nombre: "Torneo de Billar · Primavera",
    fecha: "8 de marzo, 2026",
    hora: "18:00 h",
    lugar: "Sala de Billar",
    salon: "Sala de Billar",
    estado: "Últimos lugares",
    precio: "$650 MXN",
    precioDesde: "$650 MXN",
    descripcion:
      "La edición de primavera del clásico torneo de billar del club. Formato eliminación directa, con premios para los tres primeros lugares y cena de clausura incluida.",
    codigoVestimenta: "Casual elegante",
    informacionAdicional:
      "Cupo limitado a 32 competidores. Inscripción cierra 72 horas antes del evento. Se entregarán tacos oficiales conmemorativos a los participantes.",
    imagen:
      "https://images.unsplash.com/photo-1762086091607-1dfd5fa60a67?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBwcml2YXRlJTIwY2x1YiUyMGludGVyaW9yfGVufDB8fHx8MTc4MzYyNTkxMXww&ixlib=rb-4.1.0&q=85",
    mesas: [
      { numero: 1, capacidad: 6, disponibles: 4, x: 25, y: 30 },
      { numero: 2, capacidad: 6, disponibles: 2, x: 55, y: 30 },
      { numero: 3, capacidad: 6, disponibles: 0, x: 25, y: 68 },
      { numero: 4, capacidad: 6, disponibles: 5, x: 55, y: 68 },
    ],
  },
  {
    id: "cena-catadores",
    nombre: "Cena para catadores",
    fecha: "29 de marzo, 2026",
    hora: "21:00 h",
    lugar: "Salón del Puerto",
    salon: "Salón del Puerto",
    estado: "Próximamente",
    precio: "$2,400 MXN",
    precioDesde: "$2,400 MXN",
    descripcion:
      "Cena maridaje de seis tiempos guiada por un sommelier invitado. Selección de vinos nacionales e internacionales acompañando la propuesta gastronómica de nuestro chef ejecutivo.",
    codigoVestimenta: "Cocktail",
    informacionAdicional:
      "Experiencia exclusiva para 40 comensales. Cupo por membresía: dos personas. Se recomienda no asistir con perfumes intensos para preservar la cata.",
    imagen:
      "https://images.unsplash.com/photo-1773855742951-10cd0b8aff6d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBwcml2YXRlJTIwY2x1YiUyMGludGVyaW9yfGVufDB8fHx8MTc4MzYyNTkxMXww&ixlib=rb-4.1.0&q=85",
    // Aún sin mesas configuradas: se mostrará el estado vacío controlado.
    mesas: [],
  },
];

export const findEventoById = (id) =>
  eventosMock.find((ev) => ev.id === id) || null;
